import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { SidebarModule } from "primeng-v17/sidebar";
import { SidebarAdditionalComponentDirective } from "../../shared/primeng/sidebar-additional-component/sidebar-additional-component.directive";
import { SidebarOptionsDirective } from "../../shared/primeng/sidebar-options/sidebar-options.directive";
import { NotificationListDialogComponent } from "./notification-list-dialog/notification-list-dialog.component";
import { NewUiNotificationsComponent } from "./new-ui-notifications.component";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SidebarModule,
    SidebarAdditionalComponentDirective,
    SidebarOptionsDirective,
    NgIf,
    NotificationListDialogComponent,
  ],
})
export class NotificationsComponent extends NewUiNotificationsComponent {}
